import { render, staticRenderFns } from "./wf-overridable-optional-date-edit.vue?vue&type=template&id=08821b4a&scoped=true&"
import script from "./wf-overridable-optional-date-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-overridable-optional-date-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-overridable-optional-date-edit.vue?vue&type=style&index=0&id=08821b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08821b4a",
  null
  
)

export default component.exports